import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { api } from './rtkClient'

const appReducer = combineReducers({
  [api.reducerPath]: api.reducer,
})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})